import { render } from "./EditAssistanceNote.vue?vue&type=template&id=f0aa2550&scoped=true"
import script from "./EditAssistanceNote.vue?vue&type=script&lang=js"
export * from "./EditAssistanceNote.vue?vue&type=script&lang=js"

import "./EditAssistanceNote.vue?vue&type=style&index=0&id=f0aa2550&lang=css"
import "./EditAssistanceNote.vue?vue&type=style&index=1&id=f0aa2550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aa2550"]])

export default __exports__